import types from '../mutation-types';
import ContactAPI from '../../api/contacts';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isError: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getContactLabels: $state => id => {
    return $state.records[Number(id)] || [];
  },
};

export const actions = {
  get: async ({ commit }, contactId) => {
    commit(types.SET_CONTACT_LABELS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await ContactAPI.getContactLabels(contactId);
      commit(types.SET_CONTACT_LABELS, {
        id: contactId,
        data: response.data.payload,
      });
      commit(types.SET_CONTACT_LABELS_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.SET_CONTACT_LABELS_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  update: async ({ commit, rootState }, { contactId, labels }) => {
    commit(types.SET_CONTACT_LABELS_UI_FLAG, {
      isUpdating: true,
    });
    try {
      const response = await ContactAPI.updateContactLabels(contactId, labels);
      commit(types.SET_CONTACT_LABELS, {
        id: contactId,
        data: response.data.payload,
      });
      // Also sync onto the cached contact record (root `contacts` module) so
      // any UI reading the contact directly (e.g. the contact profile page)
      // reflects the change immediately instead of only after a reload.
      const existingContact = rootState.contacts?.records?.[contactId];
      if (existingContact) {
        commit(
          types.EDIT_CONTACT,
          { ...existingContact, labels: response.data.payload },
          { root: true }
        );
      }
      // Also sync directly onto any currently loaded conversations for this
      // contact. The conversation list reads `conversation.labels` as a
      // plain prop (not through a nested getter), so this is what actually
      // makes the badge next to the customer's name update immediately
      // without a page reload.
      const matchingConversations = (
        rootState.conversations?.allConversations || []
      ).filter(chat => chat.meta?.sender?.id === Number(contactId));
      matchingConversations.forEach(chat => {
        commit(
          types.UPDATE_CONVERSATION,
          {
            id: chat.id,
            labels: Array.from(
              new Set([...(chat.labels || []), ...response.data.payload])
            ),
          },
          { root: true }
        );
      });
      commit(types.SET_CONTACT_LABELS_UI_FLAG, {
        isUpdating: false,
        isError: false,
      });
    } catch (error) {
      commit(types.SET_CONTACT_LABELS_UI_FLAG, {
        isUpdating: false,
        isError: true,
      });
      throw new Error(error);
    }
  },
  setContactLabel({ commit }, { id, data }) {
    commit(types.SET_CONTACT_LABELS, { id, data });
  },
};

export const mutations = {
  [types.SET_CONTACT_LABELS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_CONTACT_LABELS]: ($state, { id, data }) => {
    $state.records = {
      ...$state.records,
      [id]: data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
